import { getFlagSummary, getResolveRooms } from "../state/roomState";

export default function ResolvePanel({ rooms, selectedRoomId, onSelectRoom }) {
  const resolveRooms = getResolveRooms(rooms);

  return (
    <section className="panel section resolve-panel">
      <div className="section-head">
        <div>
          <div className="eyebrow">Suggested Rooms</div>
          <h3>Resolve these rooms next</h3>
          <p>Recently harvested rooms and low-activity rooms are listed in one clean queue so room selection happens after planning, not beside it.</p>
        </div>
        <div className="pill pill-soft">{resolveRooms.length} rooms ready</div>
      </div>
      <div className="resolve-grid">
        {resolveRooms.map((room) => {
          const { failing } = getFlagSummary(room);
          const statusCls = room.status === "resolve" ? "pill-bad" : room.status === "watch" ? "pill-warn" : "pill-good";
          return (
            <button
              key={room.id}
              type="button"
              className={"resolve-card" + (room.id === selectedRoomId ? " active" : "") + (failing.length ? " flagged" : "")}
              onClick={() => onSelectRoom(room.id)}
            >
              <div className={"pill " + statusCls}>{room.stage}</div>
              <div className="resolve-main">
                <h4>{room.label || room.id}</h4>
                <p>{room.reason}</p>
              </div>
              <div className="resolve-stats">
                <div><span>Events</span><strong>{room.weeklyEvents.length}</strong></div>
                <div><span>Flags</span><strong>{failing.length}</strong></div>
                <div><span>Saved</span><strong>{room.savedAt ? "Yes" : "No"}</strong></div>
              </div>
            </button>
          );
        })}
      </div>
    </section>
  );
}
